<div class="page-wrapper">
  <div class="page-header">
    <h1>{{ ("demoSettings" | i18n) || "Demo Settings" }}</h1>
  </div>
  <div class="page-content">
    <div
      *ngIf="demoValidUntil$ | async as validUntil"
      data-cy="demo-duration-hint"
      class="card-box"
      [class.hint-card]="!(isExpired$ | async)"
      [class.warning-card]="isExpired$ | async">
      <div *ngIf="!(isExpired$ | async)">
        {{
          "demoDurationHint"
            | i18n
              : {
                  validUntil: (validUntil | date: "dd.MM.yyyy"),
                  remainingDays: (remainingDays$ | async)
                }
        }}
      </div>
      <div *ngIf="isExpired$ | async">
        <ng-container *ngIf="(remainingDays$ | async) === 0">
          {{
            "demoExpiredTodayHint"
              | i18n
                : {
                    expiredAt: (validUntil | date: "dd.MM.yyyy")
                  }
          }}
        </ng-container>
        <ng-container *ngIf="(remainingDays$ | async)! < 0">
          {{
            "demoExpiredHint"
              | i18n
                : {
                    expiredAt: (validUntil | date: "dd.MM.yyyy"),
                    daysAgo: (remainingDays$ | async)! * -1
                  }
          }}
        </ng-container>
      </div>
    </div>

    <div class="card-box">
      <h1 class="card-title">
        {{ "extendDurationTitle" | i18n }}
      </h1>
      <p>{{ "extendDurationDescription" | i18n }}</p>
      <mat-form-field class="light-form-field">
        <mat-label>{{ "newValidUntilDate" | i18n }}</mat-label>
        <input
          matInput
          [value]="validUntilControl.value | date"
          readonly
          (click)="picker.open()"
          data-cy="extend-duration-datepicker" />
        <input
          matInput
          [matDatepicker]="picker"
          [formControl]="validUntilControl"
          [min]="demoValidUntil$ | async"
          (click)="picker.open()"
          hidden />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <button
        mat-raised-button
        color="primary"
        (click)="onSaveExtendDuration()"
        [disabled]="!validUntilControl.dirty || !validUntilControl.value"
        data-cy="save-extend-duration-button">
        {{ ("save" | i18n) || "Speichern" }}
      </button>
    </div>

    <div class="card-box">
      <div class="danger-actions">
        <button
          *ngIf="!(isExpired$ | async)"
          mat-raised-button
          color="warn"
          (click)="disableDemo()"
          data-cy="disable-demo-button">
          {{ "disableDemo" | i18n }}
        </button>
        <button
          mat-raised-button
          color="warn"
          (click)="deleteDemo()"
          data-cy="delete-demo-button">
          {{ "deleteDemo" | i18n }}
        </button>
        <button
          *ngIf="!(isExpired$ | async)"
          mat-raised-button
          color="primary"
          (click)="switchToLive()"
          data-cy="switch-to-live-button">
          {{ "switchToLive" | i18n }}
        </button>
      </div>
    </div>
  </div>
</div>
